import { TextFieldProps } from '@material-ui/core/TextField';
import { Filter, StatusesKeys } from '../../types';
import { MedisanteTargetSystem } from '../../../TargetSystems/types';
import { MedisanteDevice } from '../../../Device/types';
import { SortOption } from '../../../../utils/sort';

export enum DevicesSortBy {
  SERIAL_NUMBER = 'SERIAL_NUMBER',
  IMEI = 'IMEI',
  MODEL = 'MODEL',
  MEASUREMENTS = 'MEASUREMENTS',
  STATUS = 'STATUS',
  LAST_MEASUREMENT = 'LAST_MEASUREMENT',
  LAST_SYNC = 'LAST_SYNC',
  MAC = 'MAC',
}
export interface Props {
  readonly filters: Filter[];
  readonly deviceCount: number;
  readonly measurementCount: number;
  readonly visibleDevices?: MedisanteDevice[];
  readonly additionalFields?: JSX.Element[];
  readonly targetSystems: MedisanteTargetSystem[];
  readonly minLastStatusCode?: number;
  readonly dashboard?: boolean;
  updateSortState?: React.Dispatch<SortOption<DevicesSortBy>>;
  sortOptionId: string | undefined;
}

export interface Categories {
  [k: string]: string[];
}

export interface CategoriesLabel {
  [k: string]: string;
}

export interface TextFilterCategory {
  readonly id: string;
  readonly label: string;
}

export interface AlertCategory {
  label: string;
  queryKey: string;
  queryValue: string;
}

export type AlertCategories = {
  [key in StatusesKeys]: AlertCategory;
};

export enum NumberComparisonType {
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  EQUAL = 'EQUAL',
}

export interface NumberFilterInputAdornmentProps {
  comparisonType?: NumberComparisonType | null;
  onChange: (type: NumberComparisonType) => void;
  disabled?: boolean;
}

interface NumberFilterAdditionalProps {
  addFilter: (filters: Filter[]) => void;
}

export type NumberFilterProps = TextFieldProps & NumberFilterAdditionalProps;

export interface NumberFilter {
  value: number;
  comparison: NumberComparisonType;
}

export interface ArchiveDevicesFilterProps {
  className?: string;
  filters: Filter[];
  updateFilters: (filters: Filter[]) => void;
  disabled?: boolean;
}

export interface TestDevicesFilterProps {
  className?: string;
  filters: Filter[];
  updateFilters: (filters: Filter[]) => void;
  disabled?: boolean;
}
